<div class="legend">
    <div class="legend-header">
        <div>
            Assignment Status
        </div>
        <button mat-icon-button
                class="configure-button"
                (click)="openConfiguration()"
                matTooltip="Configure Assignment Status Map"
        >
            <mat-icon>settings</mat-icon>
        </button>
    </div>
    <div class="legend-subtitle">
        <span>Service status of routes</span>
    </div>
    <div class="legend-line">
        <div class="legend-item__wrapper">
            <app-line-dash-array-view
              [dashArray]="userTrackStyles.assignmentStatusServiced.dasharray"
              [color]="userTrackStyles.assignmentStatusServiced.color"
            ></app-line-dash-array-view>

            <div class="legend-item__name">
                Serviced
            </div>
        </div>
        <div class="legend-item__wrapper">
          <app-line-dash-array-view
            [dashArray]="userTrackStyles.assignmentStatusInProgress.dasharray"
            [color]="userTrackStyles.assignmentStatusInProgress.color"
          ></app-line-dash-array-view>

            <div class="legend-item__name">
                In Progress
            </div>
        </div>
        <div class="legend-item__wrapper">
          <app-line-dash-array-view
            [dashArray]="userTrackStyles.assignmentStatusNotServiced.dasharray"
            [color]="userTrackStyles.assignmentStatusNotServiced.color"
          ></app-line-dash-array-view>

            <div class="legend-item__name">
                Not Serviced
            </div>
        </div>
    </div>
</div>
